/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.$ = window.jQuery = require('jquery');
require('slick-carousel');

require('./modernizr.webp');
require('./app.jquery');

import { createApp } from "vue";
import App from "./components/vue/App.vue";

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const app = createApp(App);

app.mount("#app");
